export const BASE_URL: string = process.env.REACT_APP_BASE_URL as string;
export const STAGE: string = process.env.REACT_APP_STAGE as string;